import React from 'react'
import PropTypes from 'prop-types'
import SpookySkeleton from '../SpookySkeleton'
import SkeletonTable, { TableHeader, TableBody, TableRow } from '../SkeletonTable'
import styles from './styles'

const SkeletonTableBasic = ({ rows = 5 }) => {
  const rowsArray = Array.from(Array(rows).keys())
  return (
    <SpookySkeleton>
      <SkeletonTable>
        <TableHeader>
          <div className={styles.row} />
        </TableHeader>

        <TableBody>
          {rowsArray.map(row => (
            <TableRow key={row}>
              <div className={styles.row} />
            </TableRow>
          ))}
        </TableBody>
      </SkeletonTable>
    </SpookySkeleton>
  )
}

SkeletonTableBasic.propTypes = { rows: PropTypes.number }

export default SkeletonTableBasic
